export default "<m-cube\n    color=\"yellow\"\n    y=\"2\"\n    sx=\"3\"\n    sy=\"4\"\n    sz=\"2\"\n></m-cube>\n";